import { MagicConfigMixin, ModalMixin, SessionChange } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { MessagePriority, MessageStatus } from '@gig/magic-sdk/dist/adapter/messages/message';
import { magic } from '@gig/magic-sdk';
import { isHidden, isResponsibleGamingAlert } from '../../util/messages.js';
import { MESSAGING_LOADED, MESSAGING_LIST } from '@gig/magic-messages';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let MessagePrompterComponent = class extends Mixins(MagicConfigMixin, ModalMixin) {
  constructor() {
    super(...arguments);
    this.openMessageId = "";
    this.messages = [];
  }
  created() {
    this.messageSubscription = window.eventBus.subscribe(MESSAGING_LOADED, (event) => __async(this, null, function* () {
      if (!event.payload) {
        this.messages = [];
        return;
      }
      this.messages = yield window.queryBus.query(MESSAGING_LIST);
      this.checkMessages();
    }), { replay: true });
  }
  onDisableAlertsChange() {
    this.checkMessages();
  }
  destroyed() {
    var _a;
    (_a = this.messageSubscription) == null ? void 0 : _a.unsubscribe();
  }
  get hasPopOpenMessage() {
    return this.messages.some((message) => message.priority === MessagePriority.POP_OPEN && !isHidden(message));
  }
  checkMessages() {
    if (this.shouldDisableAlerts && !this.hasPopOpenMessage) {
      return;
    }
    let hasModalOpen = false;
    let hasResponsibleGamingAlert = false;
    const messagesToShow = this.messages.filter((message) => message.status === MessageStatus.NEW && (isResponsibleGamingAlert(message) || message.priority === MessagePriority.POP_OPEN));
    if (messagesToShow.length > 0) {
      const responsibleGamingAlert = messagesToShow.filter((message2) => isResponsibleGamingAlert(message2));
      let message;
      if (responsibleGamingAlert.length > 0) {
        hasResponsibleGamingAlert = true;
        message = responsibleGamingAlert[0];
      } else {
        message = messagesToShow[0];
      }
      hasModalOpen = true;
      let modalElement = null;
      if (this.openMessageId === message.id) {
        return;
      }
      this.closeModal();
      if (hasResponsibleGamingAlert) {
        modalElement = this.openModal(this.renderedModal, this.header || null, { dismissible: false });
        modalElement.addEventListener("acknowledged", () => {
          this.closeModal();
          this.acknowledge(message);
        });
      } else {
        modalElement = this.openModal(this.renderedModal, this.header || null, {
          dismissible: true,
          keepAfterClear: true,
          onClose: () => {
            this.confirm(message);
          }
        });
      }
      modalElement.message = message;
      modalElement.hideBacklink = true;
      modalElement.addEventListener("ctaClicked", (event) => {
        this.closeModal();
        if (hasResponsibleGamingAlert) {
          this.visitedUrl(message, event.detail[0]);
        }
      });
      this.openMessageId = message.id;
    }
    if (!hasModalOpen) {
      this.closeModal();
    }
  }
  onSessionChange(isLoggedIn) {
    if (!isLoggedIn) {
      this.closeModal();
    }
  }
  render() {
    return null;
  }
  acknowledge(message) {
    magic.methods.users.addNote(`User acknowledged at ${new Date().toISOString()} UTC: ${message.subject}`);
    this.confirm(message);
    return message.id;
  }
  visitedUrl(message, cta) {
    const url = cta === "primary" ? message.url : message.url2;
    magic.methods.users.addNote(`User visited ${url} page at ${new Date().toISOString()} UTC: ${message.subject}`);
    this.confirm(message);
  }
  confirm(message) {
    (() => __async(this, null, function* () {
      try {
        if (message.once) {
          yield magic.methods.messages.archive(message.id);
        } else {
          yield magic.methods.messages.markAsRead(message.id);
          this.messageRead(message.id);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.openMessageId = "";
      }
    }))();
  }
  messageRead(id) {
    return { id, isPopOpen: true };
  }
};
__decorateClass([
  Prop({
    type: Boolean,
    default: false
  })
], MessagePrompterComponent.prototype, "shouldDisableAlerts", 2);
__decorateClass([
  Prop({
    type: String,
    default: "magic-message"
  })
], MessagePrompterComponent.prototype, "renderedModal", 2);
__decorateClass([
  Prop({
    type: String,
    default: null
  })
], MessagePrompterComponent.prototype, "header", 2);
__decorateClass([
  Watch("shouldDisableAlerts")
], MessagePrompterComponent.prototype, "onDisableAlertsChange", 1);
__decorateClass([
  SessionChange({ immediate: true })
], MessagePrompterComponent.prototype, "onSessionChange", 1);
__decorateClass([
  Emit("acknowledge")
], MessagePrompterComponent.prototype, "acknowledge", 1);
__decorateClass([
  Emit("message-read")
], MessagePrompterComponent.prototype, "messageRead", 1);
MessagePrompterComponent = __decorateClass([
  Component({
    name: "message-prompter"
  })
], MessagePrompterComponent);

export { MessagePrompterComponent };
